<template>
  <div>
    <div class="google-map" ref="googleMap"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>

<script>

import { Loader } from '@googlemaps/js-api-loader';

export default {
  name: 'GoogleMapLoader',
  props: {
    mapConfig: Object,
  },
  data() {
    return {
      google: null,
      map: null,
      apiKey: 'AIzaSyCxaYNA5h-57d52ZQ9KK__YsBHoxpZEims',
    };
  },
  async mounted() {
    const googleMapApi = new Loader({
      apiKey: this.apiKey,
      version: 'weekly',
    });
    await googleMapApi.load()
      .then((google) => {
        this.google = google;
        this.initializeMap();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 93vh;
}
</style>
